
import { Home, DollarSign, BookOpen } from "lucide-react";
import { TubelightNavBar } from "@/components/ui/tubelight-navbar";
import { LogIn } from "lucide-react";
import { cn } from "@/lib/utils";
import { APP_PRICING_URL, APP_SIGN_IN_URL } from "@/lib/appUrls";

interface DesktopNavProps {
  scrollToSection: (id: string) => void;
}

const DesktopNav = ({ scrollToSection }: DesktopNavProps) => {
  const navItems = [
    { 
      name: 'Home', 
      url: '/', 
      icon: Home,
      onClick: () => scrollToSection('hero')
    },
    { 
      name: 'Pricing', 
      url: APP_PRICING_URL, 
      icon: DollarSign 
    },
    { 
      name: 'Blog', 
      url: '/blog', 
      icon: BookOpen 
    }
  ];

  return (
    <div className="hidden md:flex items-center justify-between w-full">
      <div className="w-40" />

      <TubelightNavBar items={navItems} />

      {/* Right section - auth button */}
      <div className="flex items-center">
        <a 
          href={APP_SIGN_IN_URL}
          className={cn(
            "group relative px-6 py-2.5 rounded-lg",
            "text-white font-semibold border-2 border-white/30 bg-white/5",
            "transition-all duration-300 flex items-center justify-center",
            "hover:bg-white/10 hover:border-white/50 hover:shadow-lg hover:shadow-white/10 hover:scale-105 gap-2"
          )}
        >
          <LogIn size={18} />
          <span>Sign In</span>
        </a>
      </div>
    </div>
  );
};

export default DesktopNav;
